module.exports = __webpack_public_path__ + "img/8.569a6c2d.svg";